import React from "react";
import { Dialog } from "primereact/dialog";
import { SendStationModalContent, SendStationModalFooter } from "./components";
import * as styles from "./SendStationStatisticModal.module.css";
import { useSendStation } from "../../../../context/SendStationContext";

export const SendStationStatisticModal = ({ statRef }) => {
  const { sendEmailModalOpen, setSendEmailModalOpen } = useSendStation();
  return (
    <Dialog
      header="Send Station Statistic"
      visible={sendEmailModalOpen}
      onHide={() => setSendEmailModalOpen(false)}
      draggable={false}
      modal
      className={styles.sendStationStatisticModal}
      footer={() => <SendStationModalFooter statRef={statRef} />}
    >
      <SendStationModalContent />
    </Dialog>
  );
};
